import { QBadge, QLookup, QText } from '@qualio/ui-components';
import { QObjectFieldType } from '../../../../types/formFields/common';
import i18n from '../../../../i18n/config';

const eventsView: QLookup.DataView<QLookup.DataProvider.V2Result> = {
  identifiers: {
    header: i18n.t('common.labels.id'),
    render: ({ code }) => <QBadge>{code}</QBadge>,
  },
  name: {
    header: i18n.t('common.labels.title'),
    render: (title) => <QText>{title}</QText>,
  },
  owner: {
    header: i18n.t('common.labels.owner'),
    render: (owner) => <QText> {owner ? owner.fullName : ''}</QText>,
  },
};

const documentsView: QLookup.DataView<QLookup.DataProvider.V2Result> = {
  identifiers: {
    header: i18n.t('common.labels.id'),
    render: ({ code }) => <QBadge>{code}</QBadge>,
  },
  name: {
    header: i18n.t('common.labels.title'),
    render: (title) => <QText>{title}</QText>,
  },
};

const usersView: QLookup.DataView<QLookup.DataProvider.V2Result> = {
  name: {
    header: i18n.t('common.labels.name'),
    render: (name) => <QText>{name}</QText>,
  },
  identifiers: {
    header: i18n.t('common.labels.email'),
    render: ({ code }) => <QBadge>{code}</QBadge>,
  },
};

const suppliersView: QLookup.DataView<QLookup.DataProvider.V2Result> = {
  name: {
    header: i18n.t('common.labels.name'),
    render: (name) => <QText>{name}</QText>,
  },
};

const changeRequestView: QLookup.DataView<QLookup.DataProvider.V2Result> = {
  identifiers: {
    header: i18n.t('common.labels.id'),
    render: ({ code }) => <QBadge>{code}</QBadge>,
  },
  name: {
    header: i18n.t('common.labels.title'),
    render: (title) => <QText>{title}</QText>,
  },
};

const RegistryView: QLookup.DataView<QLookup.DataProvider.V2Result> = {
  identifiers: {
    header: i18n.t('common.labels.id'),
    render: ({ code }) => <QBadge>{code}</QBadge>,
  },
  name: {
    header: i18n.t('common.labels.title'),
    render: (title) => <QText>{title}</QText>,
  },
};

const DesignControlsView: QLookup.DataView<QLookup.DataProvider.V2Result> = {
  identifiers: {
    header: i18n.t('common.labels.id'),
    render: ({ code }) => <QBadge>{code}</QBadge>,
  },
  name: {
    header: i18n.t('common.labels.title'),
    render: (title) => <QText>{title}</QText>,
  },
};

const TrainingView: QLookup.DataView<QLookup.DataProvider.V2Result> = {
  identifiers: {
    header: i18n.t('common.labels.id'),
    render: ({ code }) => <QBadge>{code}</QBadge>,
  },
  name: {
    header: i18n.t('common.labels.title'),
    render: (title) => <QText>{title}</QText>,
  },
};

const DocumentTemplateView: QLookup.DataView<QLookup.DataProvider.V2Result> = {
  identifiers: {
    header: i18n.t('common.labels.id'),
    render: ({ code }) => <QBadge>{code}</QBadge>,
  },
  name: {
    header: i18n.t('common.labels.title'),
    render: (title) => <QText>{title}</QText>,
  },
};

const EventTemplateView: QLookup.DataView<QLookup.DataProvider.V2Result> = {
  identifiers: {
    header: i18n.t('common.labels.id'),
    render: ({ code }) => <QBadge>{code}</QBadge>,
  },
  name: {
    header: i18n.t('common.labels.title'),
    render: (title) => <QText>{title}</QText>,
  },
};

const TaskView: QLookup.DataView<QLookup.DataProvider.V2Result> = {
  identifiers: {
    header: i18n.t('common.labels.id'),
    render: ({ code }) => <QBadge>{code}</QBadge>,
  },
  name: {
    header: i18n.t('common.labels.name'),
    render: (name) => <QText>{name}</QText>,
  },
};

export const ViewMap = {
  event: eventsView,
  document: documentsView,
  user: usersView,
  supplier: suppliersView,
  change_request: changeRequestView,
  registry: RegistryView,
  design_controls: DesignControlsView,
  training_plan: TrainingView,
  document_template: DocumentTemplateView,
  event_template: EventTemplateView,
  task: TaskView,
} as const satisfies Record<QObjectFieldType, QLookup.DataView<unknown>>;
